document.addEventListener('DOMContentLoaded', () => {

    const background = document.querySelector('.previous-attenuation-sibling')

    if (background) {

        const observer = new MutationObserver(toggleScrollLock);

        observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });

        toggleScrollLock();

        let isLocked = false

        let lastScrollY = window.scrollY;

        let scrollDirection = null;

        let startY = 0;

        let endY = 0;

        window.addEventListener('wheel', (e) => {

            if (!isLocked) return;

            e.preventDefault();

            const delta = e.deltaY > 0 ? 5 : -5;

            updateRotation(delta);

        }, { passive: false });

        // Optional: touch support
        let lastTouchY = null;

        window.addEventListener('touchstart', (e) => {
            lastTouchY = e.touches[0].clientY;
            startY = lastTouchY
        });

        window.addEventListener('touchmove', (e) => {

            if (!isLocked) return;

            const currentY = e.touches[0].clientY;

            const deltaY = lastTouchY - currentY;

            const delta = deltaY > 0 ? 1 : -1

            checkScrollLockTrigger();

            lastTouchY = currentY;

        }, { passive: false });


        window.addEventListener('touchend', function (e) {
            endY = e.changedTouches[0].clientY;
            handleSwipe();
        });

        window.addEventListener('scroll', () => {

            scrollDirection = window.scrollY > lastScrollY ? 'down' : 'up';

            lastScrollY = window.scrollY;

            checkScrollLockTrigger();
        });

        function handleSwipe() {

            const diffY = startY - endY;

            scrollDirection = diffY > 0 ? 'down' : 'up'

            checkScrollLockTrigger()
        }

        function toggleScrollLock() {
            isLocked ? document.body.classList.add('hidden-gauge') : document.body.classList.remove('hidden-gauge')
        }

        function checkScrollLockTrigger() {

            const productSlider = document.querySelector('.previous-attenuation-sibling')

            const gallery = document.querySelector('.gallery-wrapper')

            const targets = document.querySelectorAll('.previous-attenuation-sibling, .attenuation');

            const productSliderRect = productSlider.getBoundingClientRect();

            const galleryRect = gallery.getBoundingClientRect()

            const windowHeight = window.innerHeight;

            const start = windowHeight - galleryRect.height * 0.25; // 75% of el1 enters

            const end =  windowHeight; // 100% (bottom edge of viewport)

            // Linear interpolation: 0 at start, 1 at end
            let progress = (start - productSliderRect.top) / (end - start);

            progress = Math.min(Math.max(progress, 0), 1); // Clamp between 0 and 1

            const colorValue = Math.round(255 * progress); // 0 = black, 255 = white

            const textColorValue = Math.round(255 * (1 - progress));
            
            const bgColor = `rgb(${colorValue}, ${colorValue}, ${colorValue})`;

            const textColor = `rgb(${textColorValue}, ${textColorValue}, ${textColorValue})`;

            background.querySelector('ul').style.borderColor = `rgba(238,238,238, ${progress})`

            background.querySelector('ul > li > a.active').style.borderColor = `rgba(0,42,58, ${progress})`

            gallery.style.opacity = progress === 1 ? 100 : 0

            targets.forEach(target => {

                target.style.backgroundColor = bgColor;

                target.style.color = textColor;

                if( target.querySelector('.progress') ) {

                    target.querySelector('.progress').style.stroke = textColor
                }

                target.querySelectorAll('.information p').forEach(el => {
                    el.style.color = textColor
                })
            });


        }


    }



})


